import { render } from "./NotificationPage.vue?vue&type=template&id=a3a08c54"
import script from "./NotificationPage.vue?vue&type=script&lang=js"
export * from "./NotificationPage.vue?vue&type=script&lang=js"

import "./NotificationPage.vue?vue&type=style&index=0&id=a3a08c54&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__